import * as React from 'react';
import {CSSProperties} from 'react';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../tgccGlobal';

type Props = {
    text: string; // line text
    top?: string; // relative offset
    subtext?: string // second line of text
    fontSize?: string; // how big to make fontsize
    marginSize?: string; // top/bottom spacing gap
    bulletSize?: string; // how big are bullets
    fontFamily?: string; // override font
    letterSpacing?: string; //overide space between letters
    onClick?: () => void; // action when clicked
};

const defFontSz = '36px';
const defLeftMargin = '5px';
const defRightMargin = '5px';
const defLtrSpc = '3px';
const defBltHt = '5px';

let bulletStyle: CSSProperties = {
    height: defBltHt,
    '@media (max-width:320px)': {
        height:'4px'
    }
};
    
let textStyle: CSSProperties = {
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    letterSpacing: defLtrSpc,
    fontSize: defFontSz,
    marginLeft: defLeftMargin,
    marginRight: defRightMargin,
    textAlign: 'center',
    cursor: '',
    fontWeight:700,
    '@media (max-width:1920px)': {
        letterSpacing:'10px'
    },
    '@media (max-width:1680px)': {
        letterSpacing:'10px'
    },
    '@media (max-width:1440px)': {
        letterSpacing:'10px',
    },
    '@media (max-width:414px)' : {
        textTransform: 'uppercase',
        letterSpacing: defLtrSpc,
        marginLeft: '25px',
        marginRight: '25px',
        textAlign: 'center',
        cursor: '',
    },
    '@media (max-width:375px)': {
    },
    '@media (max-width:360px)': {
        letterSpacing:'2px',
    },
    '@media (max-width:320px)' : {
        letterSpacing:defLtrSpc,
    }
};

let wrapperStyle: CSSProperties = {
    width: "100%",
    display: "flex",
    marginTop: "10px",
    marginBottom: "10px",
    opacity: 0.85,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    top: '0',
    color:'#404041',
    '@media (max-width:1920px)': {
        marginTop:'-26px'
    },
    '@media (max-width:1680px)': {
        marginTop:'-20px'
    },
    '@media (max-width:1440px)': {
        marginTop:'-20px'
    },
        '@media (min-width:768px)': {
            marginTop:'-10px'
        },
    '@media(max-width:414px)': {
        marginTop:'-5px'
    },
    '@media (max-width:375px)': {
        marginTop:'0px'
    },
    '@media (max-width:320px)': {
        marginTop:'3px'
    }
};

let containerStyle : CSSProperties = {
    display: 'flex', 
    alignSelf: 'center', 
    flexDirection: 'column',
    color:'#404041',
    width: '100%'
};
    
let bulletContainerStyle : CSSProperties = {
    width: "100%",
    display: "flex",
    marginTop: "10px",
    marginBottom: "10px",
    opacity: 0.85,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: "center",
    position: 'relative',
    top: '0',
};

class _BulletLine extends React.Component < Props, any > {

    subtextElement = null;
    onResize = () => {
        this.forceUpdate();
    
    }
    componentWillMount() {
        bulletStyle.height = this.props.bulletSize || bulletStyle.height;
        textStyle.fontSize = this.props.fontSize || defFontSz;
        textStyle.letterSpacing = this.props.letterSpacing || defLtrSpc;
        textStyle.marginLeft = this.props.fontSize || defFontSz;
        textStyle.marginRight = this.props.fontSize || defFontSz;
        textStyle.fontFamily = this.props.fontFamily || textStyle.fontFamily;
        wrapperStyle.top = this.props.top;
        if(this.props.onClick)
            textStyle.cursor = "pointer"; 
        if(this.props.marginSize){
            wrapperStyle.marginTop = this.props.marginSize;
            wrapperStyle.marginBottom = this.props.marginSize;
        }
        this.subtextElement = this.getSubTextElement(this.props.subtext);

        this.onResize();
    }
    componentDidMount() {
        window.addEventListener("resize", this.onResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }
  

    getSubTextElement(txt : string) {
        if (!txt) {
            return (
                <div></div>
            )
        } else {
            return (
                <div style={wrapperStyle} onClick={this.props.onClick}>
                    <div style={textStyle}>{txt}</div>
                </div>
            )
        }
    }
    render() {
        
        textStyle.fontSize = this.props.fontSize || defFontSz;
        bulletStyle.height = this.props.bulletSize || defBltHt;
        if (window.innerWidth < 1280){
             var multiplier = window.innerWidth / 1280;
             var tsize = Math.max(16, (parseInt(textStyle.fontSize as string) * multiplier));
             textStyle.fontSize =  tsize + 'px';
             var bsize = Math.max(3, (parseInt(bulletStyle.height as string) * multiplier));
             bulletStyle.height = bsize + 'px';
        }
     
        return (
            <div style={containerStyle}>
                <div style={bulletContainerStyle}>
                    <img src={Tgcc.ResolveUrl('~/images/bullet_line_left.svg')} style={bulletStyle} />
                    <div style={textStyle} onClick={this.props.onClick}>{this.props.text}</div>
                    <img src={Tgcc.ResolveUrl('~/images/bullet_line_right.svg')} style={bulletStyle}/>
                </div>
                {this.subtextElement}
            </div>
        )
    }
}

export var BulletLine = Radium(_BulletLine); 